<template>
  <div class="regist-page">
    <van-form class="regist-form" @submit="onRegistSubmit" ref="registForm">
      <div class="regist-form-tittle">新用户注册</div>
      <van-field
        border
        name="phone"
        v-model="registForm.phone"
        placeholder="请输入您的手机号码"
        :rules="rules.phone"
        :error-message="errMsg.phone"
      />
      <div class="regist-form-validate">
        <!--  :rules="rules.webValidateCode" -->
        <van-field
          class="form-validate-realcode"
          border
          v-model="registForm.webValidateCode"
          placeholder="输入验证码"
          :rules="rules.webValidateCode"
          :error-message="errMsg.webValidateCode"
        />
        <!-- 在使用这些按钮时，要注意将native-type设置为button，否则会触发表单提交。 -->
        <van-button
          class="regist-form-validate-code"
          type="primary"
          native-type="button"
          @click="getapiUserPhoneSms('regist', '300')"
          v-show="showValidateButton"
          :disabled="disableGetValidateCode"
        >获取验证码</van-button>
        <!-- 计时器 -->
        <van-button
          class="regist-form-validate-code"
          type="warning"
          disabled
          native-type="button"
          v-show="!showValidateButton"
        >{{ time }}s</van-button>
      </div>
      <van-field
        class="regist-form-password"
        border
        v-model="registForm.password"
        type="password"
        placeholder="输入密码"
        :rules="rules.password"
        :error-message="errMsg.password"
      />
      <van-field
        class="regist-form-password"
        border
        type="password"
        name="passwordAgain"
        v-model="registForm.passwordAgain"
        placeholder="再次输入密码"
        :rules="rules.passwordAgain"
        :error-message="errMsg.passwordAgain"
      />
      <van-checkbox
        class="regist-form-protocal"
        v-model="registForm.checkedProtocol"
        shape="square"
      >
        同意
        <span @click="showProtocal('privacy', '隐私协议')">《隐私协议》</span>
        <span @click="showProtocal('serve', '游记协议')">《游记协议》</span>
      </van-checkbox>
      <div class="regist-form-noprotocal" v-show="showNoProtocal">未同意《隐私协议》《游记协议》无法注册</div>
      <!-- 原生 button 标签的 type 属性native-type -->
      <van-button  class="regist-form-login" type="primary" native-type="submit">{{btntext}}</van-button>
      <div class="other-entrance">
         <span class="already-has-account">已有账号&nbsp;&nbsp;</span>
         <span class="other-entrance-login" @click="gotoLogin()">登录</span>
      </div>
    </van-form>
    <GlobalLoading :showLoading="showLoading" />
    <van-dialog
      v-model="dialog.show"
      :title="dialog.title"
      closeOnClickOverlay
      :showConfirmButton="false"
    >
      <div style="overflow:auto;height:50vh;padding: 5px 5px;">
        <protocal-privacy v-if="dialog.content == 'privacy'"></protocal-privacy>
        <protocal-serve v-if="dialog.content == 'serve'"></protocal-serve>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { apiUserPhoneSms, checkVerifyCode,userRegist,checkPhoneUsed } from "@/axios/service/user";
import { Form, Button, Field, Checkbox, Dialog, Toast } from "vant";
import protocalServe from "@/components/protocal/serve";
import protocalPrivacy from "@/components/protocal/privacy";
import TrIdentify from "@/components/kits/identify";
import GlobalLoading from "@/mobileCom/GlobalLoading";
import { errMsgCallback,mobileMsgSuc } from "@/utils/MobileGlobal";
import {mapActions} from "vuex";
export default {
  name: "login-page",
  components: {
    GlobalLoading,
    protocalServe,
    protocalPrivacy,
    [Dialog.Component.name]: Dialog.Component,
    [Checkbox.name]: Checkbox,
    [Field.name]: Field,
    [Form.name]: Form,
    [Button.name]: Button,
    TrIdentify
  },
  mounted() {},
  data() {
    let checkPasswordAgain = (value,rule) => {
      if (value === "") {
        this.errMsg.passwordAgain = "请再次输入密码";
        return false;
      } else if (value !== this.registForm.password) {
        this.errMsg.passwordAgain = "两次密码不一致，请核对后重新输入";
        return false;
      } else {
         this.errMsg.passwordAgain = "";
        return true;
      }
    };
    let checkPassword = (value,rule) => {
      //密码需包含字母、数字、符号的组合，空格除外，“空格”除外 (!#$%^&*)
      let numberReg = /[\d]+/;
      let lowerLetter = /[a-z]+/;
      let upperLetter = /[A-Z]+/;
      let spaceLetter = /[\s]+/;
      if (value === "") {
        this.errMsg.password = "密码不能为空，请重新输入";
        return false;
      } else {
        if (
          !(
            value.match(numberReg) &&
            (value.match(lowerLetter) || value.match(upperLetter)) &&
            !value.match(spaceLetter)
          )
        ) {
          if (value.length < 8) {
            this.errMsg.password = "密码需设置8位以上，请重新输入";
            return false;
          } else {
            this.errMsg.password = "密码需包含字母、数字、符号的组合，空格除外";
            return false;
          }
        }
        // 第一个密码改了，第二个密码如果不为空则需要检验第二个密码
        if (this.registForm.checkPass2 !== "") {
          this.$refs.registForm.validate("passwordAgain");
        }
         this.errMsg.password = "";
        return true;
      }
    };
    // 校验验证码 
    let validateCodeValidator = (value, rule) => {
      let that = this;
      let reg = /^([0-9]{6}$)/;
      if (value === "") {
        this.errMsg.webValidateCode = "请输入6位数字验证码";
        return false;
      } else {
        if (!reg.test(value)) {
          this.errMsg.webValidateCode = "请输入6位数字验证码";
          return false;
        } else {
          //检查验证码是否正确,是否超时
          checkVerifyCode({
            phone: that.registForm.phone,
            validateCode: value,
            oemId: that.apolloConfig.WORK.oemId,
            validSessionId: that.registForm.webValidSessionId
          }).then(json => {
            if (json.respCode === 100) {
              that.errMsg.webValidateCode = "";
              return true;
            } else if (json.respCode === -121) {
              //验证码错误
              that.errMsg.webValidateCode = "验证码输入错误，请重新输入";
              return false;
            } else if (json.respCode === -120) {
              //验证码超时
              that.errMsg.webValidateCode = "验证码超时，请重新获取";
              return false;
            } else {
              that.errMsg.webValidateCode = "";
              return true;
            }
          });
        }
      }
    };
    // 校验函数返回 true 表示校验通过，false 表示不通过
    let phoneValidator = (value, rule) => {
      let that = this;
      let reg = /^(1[3456789][0-9]{9}$)/;
      if (value === "") {
        this.disableGetValidateCode = true; //不能点击获取验证码
        this.errMsg.phone = "请输入11位手机号码";
        return false;
      } else {
        if (!reg.test(value)) {
          this.disableGetValidateCode = true; //不能点击获取验证码
          this.errMsg.phone = "请输入11位手机号码";
          return false;
        } else {
          //如果手机号格式校验通过，则调接口判断是否是已经注册的用户
          checkPhoneUsed({
            phone: value,
            oemId: that.apolloConfig.WORK.oemId
          }).then(json => {
            if (json.respCode === 100) {
              //如果手机号是已经注册的
              if (json.data.isUserExist) {
                this.disableGetValidateCode = true; //如果当前登录用户又换了一个已经注册的手机号则也不能点击获取验证码
                this.errMsg.phone  = "该手机号已注册，可直接登录";
                return false;
              } else {
                this.errMsg.phone = "";
                //是否可以使用验证码
                this.disableGetValidateCode = false;
                return true;
              }
            } else {
              this.errMsg.phone = "";
              //是否可以使用验证码
              this.disableGetValidateCode = false;
              return true;
            }
          });
        }
      }
    };
    return {
      registError: {
        "-119": "手机号已注册",
        "-120": "验证码超时",
        "-121": "验证码错误"
      },
      showLoading: false,
      btntext: "注册",
      showNoProtocal: false,
      phoneErrorMessage: "",
      rules: {
        phone: [
          { required: true, message: "请输入手机号" },
          { validator: phoneValidator, message: "请输入手机号" }
        ],
        password: [
          { required: true, message: "请输入密码" },
          {validator: checkPassword, message: "请输入密码"}
        ],
        webValidateCode: [
          { required: true, message: "请输入验证码" },
          { validator: validateCodeValidator, message: "请输入验证码" }
        ],
        //注意：第二个密码的校验项应该只写这一项，否则this.$refs.registForm.validate("passwordAgain");触发的时候有bug
        passwordAgain: [
          {validator: checkPasswordAgain }
        ]
      },
      showValidateButton: true, //是否展示获取验证码按钮
      timer: null,
      time: 60,
      disableGetValidateCode: true, //是否允许获取验证码
      dialog: {
        show: false,
        title: "",
        content: ""
      },
      registForm: {
        phone: "",
        password: "",
        webValidateCode: "",
        passwordAgain: "",
        checkedProtocol: false,
        webValidSessionId: "",
        typeId: "4"
      },
      errMsg: {
        phone: "",
        password: "",
        webValidateCode: "",
        passwordAgain: "",
        checkedProtocol: ""
      },
      hasGotCode: false //是否获取过验证码
    };
  },
  watch: {
    "registForm.checkedProtocol"(protocalValue) {
      //如果同意协议则隐藏提示文字
      if (protocalValue) {
        this.showNoProtocal = false;
      }
    }
  },
  methods: {
    ...mapActions("MessageStore", ["pushMessageAddAction"]),
    phoneMeassage() {
      return this.phoneErrorMessage ? this.phoneErrorMessage : "请输入手机号";
    },
    gotoLogin() {
      this.$router.push({name: "login"});
    },
    showProtocal(content, title) {
      this.dialog.show = true;
      this.dialog.content = content;
      this.dialog.title = title;
    },
    //获取验证码
    getapiUserPhoneSms(state, flag) {
      let that = this;
      if (this.disableGetValidateCode) {
        return;
      }
      //根据入口判断校验哪个表单
      let res = this.$refs.registForm.validate("phone").then(
        () => {
          //电话号校验成功后发请求获取验证码
          this.showValidateButton = false;
          this.hasGotCode = true;
          this.timer = setInterval(() => {
            if (this.time == 0) {
              window.clearInterval(this.timer);
              this.showValidateButton = true;
              this.time = 60;
            }
            this.time--;
          }, 1000);
          this.disableGetValidateCode = false;
          apiUserPhoneSms(
            {
              webProductId: this.apolloConfig.WORK.oemId,
              oemId: this.apolloConfig.WORK.oemId,
              webPhone: this.registForm.phone,
              webModelType: flag,
              webCheckType: "0",
              webTypeId: this.registForm.typeId
            },
            "apiUserPhoneSms"
          ).then(res => {
            that.registForm.webValidSessionId = res.data.validSessionId;
          });
        },
        () => {
        }
      );
    },
    onRegistSubmit() {
      //如果没有选中协议则显示提示信息
      if (!this.registForm.checkedProtocol) {
        this.showNoProtocal = true;
        return;
      }
      if (!this.hasGotCode) {
        //this.$toast的使用前提是全局引入了Toast组件
        this.$toast("请点击获取验证码后，重新输入!");
        return;
      }
      this.$refs.registForm.validate().then(() => {
       
        this.btntext = "注册中";
        this.showLoading = true;
        userRegist(
          {
            webPhone: this.registForm.phone,
            webPassword: this.$md5(this.registForm.password),
            webValidSessionId: this.registForm.webValidSessionId,
            webValidateCode: this.registForm.webValidateCode,
            WebTypeId: this.registForm.typeId,
            productId: this.apolloConfig.WORK.oemId,
            appId: this.apolloConfig.WORK.appId
          },
          "userRegist"
        )
          .then(res => {
            //有返回的话先关闭loading
            this.showLoading = false;
            if (res.respCode === 100) {
              mobileMsgSuc("注册成功");
              let loginForm = {
                phone: res.data.phone,
                password: this.registForm.password,
                typeId: this.registForm.typeId
              };
              this.$cookie.set("loginForm", JSON.stringify(loginForm));
              // 注册成功后跳转至首页
              this.$router.push({ name: "login" }).catch(e => {});
              let userId = res.data.userId;
              // 注册成功推送一条注册成功的消息
              this.pushMessageAddAction({
                userId: userId,
                noticeType: this.ClearMeaningConst.noticeType_userRegister,
                dataId: userId,
                dataType: 99 //99表示用户
              });
            } else {
              errMsgCallback(res, this.registError);
            }
          })
          .finally(() => {
            this.btntext = "注册";
          });
        
      },() => {
      });
    }
  },
  beforeDestroy() {
    //清除定时器
    window.clearInterval(this.timer);
    this.timer = null;
  }
};
</script>
<style lang="less">
@import "~@/mobile_css/login_related.less";
.regist-page {
  .regist-form {
    .common_layout();
    .regist-form-password {
      margin-top:  @commonMarginTop;
    }
    .regist-form-tittle {
      .common_titile();
    }
    .van-field {
     .common_van_field();
    }
    .regist-form-validate {
     .common_validate_code();
    }
    .regist-form-protocal {
      .van-checkbox__label {
        color: #999999;
      }
      margin-top: 20px;
      font-size: 12px;
    }
    .regist-form-noprotocal {
      color: red;
      font-size: 16px;
      margin-top:@baseMarginTop;
    }
    .regist-form-login {
      border-radius: 3px;
      margin-top: @baseMarginTop;
    }
    .other-entrance {
      margin-top: @baseMarginTop;
      display: flex;
      font-size: @baseFontSize;
      justify-items: start;
      .already-has-account {
        color: #999999;
      }
      .other-entrance-login {
        color:#fe9b01;
      }
    }
  }
}
</style>
